// src/components/Auth/AdminRoute.tsx - REPLACE YOUR CURRENT VERSION
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { userInfo, isLoading } = useSelector((state: RootState) => state.user);
  
  // 🆕 CRITICAL: Show loading while authentication is being restored
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-neutral-900 to-slate-950 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-orange-500 mx-auto mb-4"></div>
          <p className="text-white text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  // Only check authentication AFTER loading is complete
  if (!userInfo) {
    return <Navigate to="/login" replace />;
  }

  // Check admin status - backend sometimes returns `admin` instead of `isAdmin`.
  // Accept either property to avoid accidental redirects when one name is used.
  const u = userInfo as unknown as Record<string, unknown>;
  const isAdminFlag = Boolean((u['isAdmin'] as unknown as boolean) ?? (u['admin'] as unknown as boolean));
  // Staff see the panel too, and change nothing on it outside the three areas they act
  // in - approving community members, casting calls, productions. Gating on isAdmin alone
  // redirected a staff account away from the panel it is entitled to see; the sidebar and
  // the backend decide what they can actually do once they are in.
  const isStaffFlag = Boolean(u['isStaff'] as unknown as boolean);
  if (import.meta.env.DEV) {
    // Debug: AdminRoute userInfo admin flags check
  }
  if (!isAdminFlag && !isStaffFlag) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;